import type { FC } from "react";
import type { CareerBackInterfacesDTOBlogBlogPreviewDto } from "../../../../shared/ApiContract/data-contracts";
import { Link } from "react-router-dom";
import { classNames } from "../../../../shared/lib/classNames";

import { BlogImage } from "../BlogImage";

import style from "./BlogCard.module.scss";

export interface BlogCardProps extends CareerBackInterfacesDTOBlogBlogPreviewDto {
    className?: string;
}

const BlogCard: FC<BlogCardProps> = ({ id, className, previewImageId, title }) => (
    <figure
        className={classNames({
            cls: style.card,
            additional: [className],
        })}
    >
        <BlogImage previewImageId={previewImageId} className={style.image} />
        <Link className={style.link} to={`/article/${id}`}>
            <figcaption>{title}</figcaption>
        </Link>
    </figure>
);

export default BlogCard;
